import { render } from "./NavigationPage.vue?vue&type=template&id=f52ac43c&scoped=true"
import script from "./NavigationPage.vue?vue&type=script&lang=js"
export * from "./NavigationPage.vue?vue&type=script&lang=js"

import "./NavigationPage.vue?vue&type=style&index=0&id=f52ac43c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52ac43c"]])

export default __exports__